<script >
export default {
  name: "PayAppFee",
  mounted() {
    fetch('https://apply.dev.aeorion.com/api/Applicant/ViewSomeThings',{
        headers: {
          'Content-Type': 'application/json', // Indicate JSON payload
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem("token")
        },
      })
        .then(response => {
          let x = response.json()
          console.log(x)
          return x
        })
  }
}
</script>

<template>
  <div>
    here is a test
  </div>
</template>

<style scoped>

</style>